import { HTTP_METHODS } from 'do-front-end-utils';
import {
  IDhwaniDashboardQueryParams,
  IDhwaniDashboardResponse,
} from '../../types/dhwani/dashboard.types';
import { sendRequestToDhwanoServiceWithCredentials } from '../../utils/request';

/**
 * Get the dashboard data
 * @description This function is used to get the dashboard data
 * @param params - The query params
 * @param params.created_start - The start date
 * @param params.created_end - The end date
 * @param params.sort - The sort by
 * @param params.status - The status
 * @returns The dashboard data
 */
export const getCampaignsApi = async (params: IDhwaniDashboardQueryParams) => {
  const response =
    await sendRequestToDhwanoServiceWithCredentials<IDhwaniDashboardResponse>({
      method: HTTP_METHODS.GET,
      url: '/screen/search/dashboard/',
      params,
      paramsSerializer: (queryParams: any) => {
        return Object.entries(queryParams)
          .filter(([_, value]) => value !== undefined) // Remove undefined values
          .map(([key, value]) => `${key}=${value}`)
          .join('&');
      },
    });
  return response;
};
